/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupstitle1Inputs */

const en_groupstitle1 = /** @type {(inputs: Groupstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group chats`)
};

const de_groupstitle1 = /** @type {(inputs: Groupstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenchats`)
};

/**
* | output |
* | --- |
* | "Group chats" |
*
* @param {Groupstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupstitle1 = /** @type {((inputs?: Groupstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupstitle1(inputs)
	return de_groupstitle1(inputs)
});
export { groupstitle1 as "groupsTitle" }